export default __webpack_public_path__ + "static/media/school.5063c85b.png";